module.exports = __webpack_public_path__ + "img/toa-pro.c0e4e107.jpg";